import React, { useState, useEffect } from "react";
import { useAuth } from "../utils/useAuth";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const { user, profile, login } = useAuth();
  const nav = useNavigate();

  // --------------- ROLE & REFEREE PROFILE REDIRECT LOGIC ----------------
  useEffect(() => {
    if (!user || !profile) return;

    const effectiveRole = profile.activeRole || profile.role;

    // ---- REFEREE PROFILE COMPLETION CHECK ----
    if (effectiveRole === "referee") {
      const missing =
        !profile.fullName ||
        !profile.contactNumber ||
        !profile.refereeCategory ||
        !profile.currentLeague;

      if (missing) {
        nav("/ref/profile");
        return;
      }
    }

    // ---- ROLE DASHBOARD REDIRECTS ----
    switch (effectiveRole) {
      case "admin":
        nav("/admin/users");
        break;
      case "manager":
        nav("/manager");
        break;
      case "coach":
        nav("/coach");
        break;
      case "referee":
        nav("/ref");
        break;
      default:
        nav("/pending");
    }
  }, [user, profile, nav]);

  // -------------------------- SUBMIT HANDLER --------------------------
  async function handle(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
    } catch (err) {
      console.error("Login error:", err);
      
      // Better error messages
      if (err.code === "auth/invalid-credential" || err.code === "auth/user-not-found") {
        alert("Invalid email or password. Please check your credentials.");
      } else if (err.code === "auth/wrong-password") {
        alert("Incorrect password. Please try again.");
      } else if (err.code === "auth/too-many-requests") {
        alert("Too many failed login attempts. Please try again later.");
      } else {
        alert("Login failed: " + err.message);
      }
    } finally {
      setLoading(false);
    }
  }

  // ----------------------------- UI -----------------------------
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <form
        onSubmit={handle}
        className="bg-white p-8 rounded shadow w-full max-w-sm"
      >
        {/* Logo/Title */}
        <div className="text-center mb-6">
          <img 
            src={`${process.env.PUBLIC_URL}/Screenshot%202026-01-15%20at%2015.04.07.png`}
            alt="RefCall Logo"
            className="mx-auto"
            style={{ width: '350px', height: 'auto' }}
          />
        </div>

        <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>

        <input
          className="w-full p-2 border rounded mb-3"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          className="w-full p-2 border rounded mb-4"
          placeholder="Password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
        />

        <button
          className="w-full bg-green-700 text-white py-2 rounded"
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>

        <p className="text-sm mt-3">
          No account?{" "}
          <Link to="/signup" className="text-blue-600">
            Sign up
          </Link>
        </p>
      </form>
    </div>
  );
}
